import { Component, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../core/services/auth.service';
import { HelperService } from '../core/services/helper.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OfficeoauthService } from '../core/services/officeoauth.service';
import { MicrosoftSessionService } from '../core/services/microsoft-session.service';
import { AppDialog } from 'src/app/core/services/app-dialog/app-dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';

@Component({
  selector: 'app-msal-redirect',
  templateUrl: './msal-redirect.component.html',
  styleUrls: ['./msal-redirect.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MaterialModule],
})
export class MsalRedirectComponent implements OnInit {
  private readonly _destroy = new Subject<void>();
  profileSiganl = signal<any>(null);
  profilePic?: SafeResourceUrl;

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: AuthService,
    private helperService: HelperService,
    private router: Router,
    private officeoauthservice: OfficeoauthService,
    private microsoftSession: MicrosoftSessionService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    // 1️⃣ Initialisation MSAL
    //await this.authServiceMsal.instance.initialize();

    this.msalService.instance.handleRedirectPromise().then(async res => {
      if (res != null && res.account != null) {
        this.msalService.instance.setActiveAccount(res.account)
        const tokenResponse = await this.msalService.instance.acquireTokenSilent({
          scopes: ['user.read'],
          account: res.account,
        });

        if (tokenResponse?.accessToken) {
          // Do NOT persist the raw Graph token: MSAL manages its own cache.
          const request = {
            username: res.account.username,
            access_token: tokenResponse.accessToken,
          };
          this.authService.login_microsoft(request).subscribe({
            next: data => {
              if (data && data.username) {
                this.authService.clearExplicitLogout();
                sessionStorage.removeItem('ms_auto_login_attempted');
                // The Microsoft session is live again: drop the header prompt.
                this.microsoftSession.markConnected();
                // login_microsoft() has already stored the user in AuthService, and
                // HelperService reads its identity from there on every access.

                this.router.navigate(['/']);

                /*const redirect = data['group'].includes('ext_kyc_bo')
                  ? 'account/kyc-dashboard'
                  : 'crm/crm-dashboard';
                setTimeout(() => {
                  this.router.navigate([redirect]);
                }, 2000);*/
              } else {
                this.connexionFailed();
                //this.router.navigate(['/login']);
              }
            },
            error: () => {
              this.connexionFailed();
              //this.router.navigate(['/login']);
            },
          });
        }
        else {
          this.connexionFailed();
        }
      }
      else {
        this.connexionFailed();
      }
    }).catch(() => {
      // prompt=none recovery refused by Entra (no AAD session): the app
      // session is usually still valid — go back to the app, no error dialog.
      if (this.authService.currentUser()) {
        this.router.navigate(['/']);
        return;
      }
      this.connexionFailed();
    })

  }

  private async handleLogin(account: any) {
    try {
      const tokenResponse = await this.msalService.instance.acquireTokenSilent({
        scopes: ['user.read'],
        account: account,
      });

      if (tokenResponse?.accessToken) {
        const request = {
          username: account.username,
          access_token: tokenResponse.accessToken,
        };

        this.authService.login_microsoft(request).subscribe({
          next: data => {
            if (this.authService.isLoggedIn()) {
              // Identity comes from AuthService: nothing to copy into HelperService.
              const redirect = data['group'].includes('ext_kyc_bo')
                ? 'account/kyc-dashboard'
                : 'crm/crm-dashboard';
              setTimeout(() => {
                this.router.navigate([redirect]);
              }, 2000);
            } else {
              this.connexionFailed();
              //this.router.navigate(['/login']);
            }
          },
          error: () => {
            this.connexionFailed();
            //this.router.navigate(['/login']);
          },
        });
      } else {
        this.connexionFailed();
        //this.router.navigate(['/login']);
      }
    } catch (error) {
      this.connexionFailed();
      //this.router.navigate(['/login']);
    }
  }


  connexionFailed() {

    AppDialog.fire({
      title: 'Microsoft authentification',
      html: `<img style="width: 50px;margin-bottom:10px" src="https://cdn.worldvectorlogo.com/logos/microsoft-5.svg"/>
        <br><label>Failed to sign in with Microsoft. Please try again or contact an administrator.</label>`,

      showCancelButton: false,
      confirmButtonText: 'Try again',
      showLoaderOnConfirm: true,
      reverseButtons: true,
      allowOutsideClick: false,
      //allowOutsideClick: () => !AppDialog.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logout().subscribe(() => {
          this.router.navigate(['/login']);
        });
      }
    });
  }

  getProfile() {
    this.officeoauthservice.getUserProfile().subscribe({
      next: profileInfo => {
        this.profileSiganl.set(profileInfo);
      },
      error: error => {
        console.error('Erreur lors de la récupération du profil:', error);
      },
    });
  }

  getProfilePic() {
    this.officeoauthservice.getUserProfilePic().subscribe({
      next: response => {
        var urlCreator = window.URL || window.webkitURL;
        this.profilePic = this.domSanitizer.bypassSecurityTrustResourceUrl(
          urlCreator.createObjectURL(response)
        );
      },
      error: error => {
        this.authService.logout().subscribe(() => {
          this.router.navigate(['/login']);
        });
        //console.error('Erreur lors de la récupération de la photo de profil:', error);
      },
    });
  }
}
